import { render, staticRenderFns } from "./Dates.vue?vue&type=template&id=072e67d8&scoped=true"
import script from "./Dates.vue?vue&type=script&lang=js"
export * from "./Dates.vue?vue&type=script&lang=js"
import style0 from "./Dates.vue?vue&type=style&index=0&id=072e67d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072e67d8",
  null
  
)

export default component.exports